export default __webpack_public_path__ + "static/media/progress-arrow.53b178c1.svg";